import Vuetify from '@/plugins/vuetify';

Vuetify.framework.lang.current = (localStorage.getItem('idioma')) ? localStorage.getItem('idioma') : 'pt';

export default {
  LIs: [],
  colunasLI: [
    {
      value: 'canalParametrizacao',
      i18n: 'parametrizacao',
      text: '',
      sortable: true,
      filterable: true,
      ativo: false,
      filterComponent: 'TextFilter',
      tooltip: true,
      width: '160px',
    },
    {
      value: 'situacao',
      i18n: 'situacao',
      text: '',
      sortable: true,
      filterable: true,
      ativo: false,
      filterComponent: 'SetFilter',
      filterParams: { filterSet: ['PARA ANALISE', 'INDEFERIDO', 'EMBARQUE AUTORIZADO', 'EM EXIGENCIA', 'DEFERIDO'], field: 'isSubstituta' },
      tooltip: true,
    },
    {
      value: 'isSubstituta',
      i18n: 'substituta',
      text: '',
      sortable: true,
      filterable: true,
      ativo: false,
      filterComponent: 'SetFilter',
      filterParams: { filterSet: ['SIM', 'NÃO'], field: 'isSubstituta' },
      tooltip: true,
      width: '150px',
    },
    {
      value: 'codigoLI',
      i18n: 'li',
      text: '',
      sortable: true,
      filterable: true,
      ativo: false,
      filterComponent: 'TextFilter',
      tooltip: true,
    },
    {
      value: 'dataSituacao',
      i18n: 'dataSituacao',
      text: '',
      sortable: true,
      filterable: true,
      ativo: false,
      filterComponent: 'DateFilter',
      tooltip: true,
    },
    {
      value: 'referenciaCliente',
      i18n: 'referenciaCliente',
      text: '',
      sortable: true,
      filterable: true,
      ativo: false,
      filterComponent: 'TextFilter',
      tooltip: true,
    },
    {
      value: 'orgaoAnuente',
      i18n: 'orgaoAnuente',
      text: '',
      sortable: true,
      filterable: true,
      ativo: false,
      filterComponent: 'TextFilter',
      tooltip: true,
    },
    {
      value: 'dataRegistro',
      i18n: 'dataReg',
      text: '',
      sortable: true,
      filterable: true,
      ativo: false,
      filterComponent: 'DateFilter',
      tooltip: true,
    },
    {
      value: 'dataValidadeSituacao',
      i18n: 'dataProtocolo',
      text: '',
      sortable: true,
      filterable: true,
      ativo: false,
      filterComponent: 'DateFilter',
      tooltip: true,
    },
    {
      value: 'actions',
      i18n: 'actions',
      text: '',
      filterable: false,
      sortable: false,
      tooltip: false,
    },
  ],
  itens: [],
  anuencia: [],
  filtros: {},
  campos: {
    canalParametrizacao: 'canalParametrizacao',
    situacao: 'situacao',
    codigoLI: 'codigoLI',
    dataSituacao: 'dataSituacao',
    referenciaCliente: 'referenciaCliente',
    orgaoAnuente: 'orgaoAnuente',
    dataRegistro: 'dataRegistro',
    dataValidadeSituacao: 'dataValidadeSituacao',
  },
};
